import { getAttribution } from '@/utils/tracking/attribution';
import { request } from '@/utils/api/request';
import { void0 } from '@/utils/void0';

import { ENDPOINT, HEADERS } from '@/constants/api';

export const account = {
  getUserDetails() {
    return request.get({
      endpoint: ENDPOINT.AUTH,
      url: '/profile/getUserInfo',
    });
  },
  updateUserDetails(payload) {
    return request.put({
      endpoint: ENDPOINT.AUTH,
      url: '/profile/updateUserInfo',
      payload,
    });
  },
  updateUserEmail(payload) {
    return request.put({
      endpoint: ENDPOINT.AUTH,
      url: '/profile/updateEmail',
      payload,
    });
  },
  updateUserPassword(payload) {
    return request.put({
      endpoint: ENDPOINT.AUTH,
      url: '/profile/updatePassword',
      payload,
    });
  },
  async uploadImageToS3({ hash, mime, data }) {
    const signedUrl = await request.get({
      endpoint: ENDPOINT.AUTH,
      url: '/profile/getImageUrl',
      params: { hash, mime },
    });

    if (signedUrl?.data?.uploadUrl) {
      return request.put({
        url: signedUrl.data.uploadUrl,
        payload: data,
        headers: { [HEADERS.CONTENT_TYPE]: mime, [HEADERS.EXPIRES]: 0 },
      });
    }

    return Promise.resolve();
  },
  /**
 * Syncs current last_touch attribution to the backend when user is logged in.
 * No-op if there is no last_touch. Call from app when auth state is known (e.g. after loggedIn is true).
 */
  syncAttributionToServer() {
    const attribution = getAttribution();
    if (!attribution?.last_touch) return Promise.resolve();

    return request.post({
      endpoint: ENDPOINT.AUTH,
      url: '/profile/attribution',
      payload: attribution.last_touch,
    })
      .catch(void0);
  },
};
